module.exports = __webpack_public_path__ + "img/title10.7c3a8f99.png";